import { useState } from 'react'
import { useWindowSize } from '../../core/hooks/useWindowSize'
import Text from '../../core/utils/Text'
import FilterLayout from '../../components/layouts/FilterLayout'
import { useProfileQuery } from '../../core/services/react-query/useInternalTransfer'
import RFilterLayout from '../../components/responsive/layouts/RFilterLayout'
import MainLayout from '../../components/layouts/MainLayout'
import CardLayout from '../../components/layouts/CardLayout'
import { TransfersTable } from '../../components/transfers/TransfersTable'
import { RTransfersTable } from '../../components/transfers/RTransfersTable'
import { useTransfers } from '../../core/hooks/useTransfers'


export default function UserTransferHistoryPage() {
    const [activeLinkIndex, setActiveLinkIndex] = useState(5)

    const { width } = useWindowSize()

    const { data: profile, isLoading: profileLoading } = useProfileQuery()

    const {
        filteredTransfers,
        transfersQueries,
        setTransfersQueries,
        transfersInitialState,
        transfersLoading,
    } = useTransfers()


    return (
        <MainLayout>
            <CardLayout className='p-6 relative overflow-y-auto overflow-x-hidden'>
                <h2 className='font-semibold'>
                    <Text tid='transfers-list' />
                </h2>

                <div className='relative' style={{ paddingBottom: width <= 1024 ? '70px' : '0' }}>
                    {width > 1024 ? (
                        <FilterLayout
                            data={filteredTransfers}
                            totalPages={filteredTransfers?.meta.total}
                            hasCoinOption={true}
                            isCurrency={true}
                            noDataTop={'200px'}
                            state={{
                                filterQueries: transfersQueries,
                                setFilterQueries: setTransfersQueries,
                                initialState: transfersInitialState,
                            }}
                            loading={profileLoading || transfersLoading}
                        >
                            {filteredTransfers?.data?.length ? (
                                <TransfersTable data={filteredTransfers.data} profileId={profile?._id} />
                            ) : null}
                        </FilterLayout>
                    ) : (
                        <RFilterLayout
                            data={filteredTransfers}
                            totalPages={filteredTransfers?.meta.total}
                            state={{
                                filterQueries: transfersQueries,
                                setFilterQueries: setTransfersQueries,
                                initialState: transfersInitialState,
                            }}
                            loading={profileLoading || transfersLoading}
                            filters={['date', 'flow']}
                        >
                            {filteredTransfers?.data?.length ? (
                                <RTransfersTable data={filteredTransfers.data} profileId={profile?._id} />
                            ) : null}
                        </RFilterLayout>
                    )}
                </div>
            </CardLayout>
        </MainLayout>
    )
}
